export const sermons = [
  {
    date: '2026-10-25',
    title: '[얼바인중앙침례교회 주일예배]  | 주님이 일하고 계십니다. | 에베소서 5:27-29',
    videoId: 'qJroOzas4do'
  },
  {
    date: '2026-10-18',
    title: '[얼바인중앙침례교회 주일예배]  | 성령을 근심하게 하지 마십시다 | 에베소서 4:30-32',
    videoId: 'DSCemy85tB8'
  },
  {
    date: '2026-10-11',
    title: '[얼바인중앙침례교회 주일예배] 다시 무릎을 꿇어야 합니다 | 에베소서 3: 14-19',
    videoId: '435wf0QNCu8'
  },
  {
    date: '2026-10-04',
    title: '[얼바인중앙침례교회 주일예배] 하나님의 증인으로 서십시오 | 사도행전 1:8',
    videoId: 'Izo4cTMAk9Y'
  },
  {
    date: '2026-09-27',
    title: '[얼바인중앙침례교회 주일예배] 하나님이 거하시는 집 | 에베소서 2:19-22',
    videoId: '_YSfgNK1wU0'
  },
  {
    date: '2026-09-20',
    title: '[얼바인중앙침례교회 주일예배] 하나님이 예비하신 길 | 에베소서 2:10',
    videoId: 'R4avO64Dl8Q'
  },
  {
    date: '2026-09-13',
    title: '[얼바인중앙침례교회 주일예배] 눈이 밝아져야 보아는 것 | 에베소서 1:18-19',
    videoId: 'xfT74clhxf0'
  },
  {
    date: '2026-09-06',
    title: '[얼바인중앙침례교회 주일예배] 그리스도 안에서 | 에베소서 1:3',
    videoId: 'IoKomR_zXYI'
  },
  {
    date: '2026-08-30',
    title: '[얼바인중앙침례교회 주일예배] 나를 기억하옵소서 | 느헤미야 13:14',
    videoId: 'vn3q30a-CdI'
  },
  {
    date: '2026-08-23',
    title: '[얼바인중앙침례교회 주일예배] 크게 즐거워하게 하시는 하나님| 느헤미야 12:43',
    videoId: 'PHZmr43486c'
  },
  {
    date: '2026-08-16',
    title: '[얼바인중앙침례교회 주일예배] 기꺼이 예루살렘으로 | 느헤미야 11:2',
    videoId: 'hN7Dc-FXxNE'
  },
  {
    date: '2026-08-09',
    title: '[얼바인중앙침례교회 주일예배] 하나님이 크게 보이면 | 느헤미야 10:39',
    videoId: 'ONyjdfVnPoc'
  },
  {
    date: '2026-08-02',
    title: '[얼바인중앙침례교회 주일예배] 행복한 예배 | 느헤미야 9:1-5',
    videoId: 'MTFvVBDz5tw'
  },
  {
    date: '2026-07-26',
    title: '[얼바인중앙침례교회 주일예배] 말씀이 살아 역사할 때 | 느헤미야 8:1-10',
    videoId: 'xRJ4kjt72_o'
  },
  {
    date: '2026-07-19',
    title: '[얼바인중앙침례교회 주일예배] 당신의 이름은 어디에 기록되어 있습니까? | 느헤미야 7:61-65',
    videoId: 'lyzsXrloW3E'
  },
  {
    date: '2026-07-12',
    title: '[얼바인중앙침례교회 주일예배] 그가 끝까지 이루시리라 | 느헤미야 6:15-16',
    videoId: '4yWwkD0Dl5c'
  },
  {
    date: '2026-07-05',
    title: '[얼바인중앙침례교회 주일예배] 맥추감사절예배 매일 말씀을 주신 하나님. | 아모스 8:11',
    videoId: 'MylNT-un7J8'
  },
  {
    date: '2026-06-28',
    title: '[얼바인중앙침례교회 주일예배] 느헤미야 강해 5. 복음이 변화를 일으킵니다. | 느헤미야 5:6-13',
    videoId: '_zq6k9SjZCU'
  },
  {
    date: '2026-06-21',
    title: '[얼바인중앙침례교회 주일예배] Father\'s Day 가족을 위해 오늘도 싸우는 아버지 | 느헤미야 4:11-14',
    videoId: '7JAaHhrqdZw'
  },
  {
    date: '2026-06-14',
    title: '[얼바인중앙침례교회 주일예배] 느헤미야 강해 3. 그 다음은 | 느헤미야 3:1-5',
    videoId: 'DJuCqHeVO_A'
  },
  {
    date: '2026-06-07',
    title: '[얼바인중앙침례교회 주일예배] 느헤미야 강해 2. 하나님의 선한 손 | 느헤미야 2:1-8',
    videoId: '6XTDWjk8EiM'
  },
  {
    date: '2026-05-31',
    title: '[얼바인중앙침례교회 주일예배] 느헤미야 강해 1. 느헤미야의 기도 | 느헤미야 1:1-5',
    videoId: 'DlF5oaEqueg'
  },
  {
    date: '2026-05-24',
    title: '[얼바인중앙침례교회 주일예배] 성령님이 이끄시는 교회 | 사도행전 2:42-47',
    videoId: 'HsqgCaerhS4'
  },
  {
    date: '2026-05-24',
    title: '성령강림주일 얼바인중앙침례교회 성가대 찬양 "불 같은 성령"',
    videoId: 'aBLW2aP5jgk'
  },
  {
    date: '2026-05-17',
    title: '[얼바인중앙침례교회 주일예배] 성령을 기다리게 하신 하나님 | 사도행전 1:4-14',
    videoId: '6ywKPyZSam8'
  },
  {
    date: '2026-05-10',
    title: '[얼바인중앙침례교회 주일예배] 생명을 하나님께 맞긴 사람 "더 숨길 수 없게 되매" | 출애굽기 2: 1-10',
    videoId: 'qjZjSLs0KvM'
  },
  {
    date: '2026-05-03',
    title: '[얼바인중앙침례교회 주일예배] 하나님이 만드신 가족. "나의 하나님이 되시리니" | 룻기 1: 16-17',
    videoId: 'K9-yrGCDZU4'
  },
  {
    date: '2026-04-26',
    title: '[얼바인중앙침례교회 주일예배] 부활 후 믿음3, 세상을 이기는 믿음, 이미 우리 안에 있습니다. | 요한1서 5:4',
    videoId: 'r_jTjzjFIb8'
  },
  {
    date: '2026-04-19',
    title: '[얼바인중앙침례교회 주일예배] 부활 후 믿음2, 작아도 순금보다 더 귀한 믿음 | 베드로전서 1:6-7',
    videoId: 'k7u0DpPrz2o'
  },
  {
    date: '2026-04-12',
    title: '[얼바인중앙침례교회 주일예배] 부활 후 믿음, 보지 않고 믿는 자가 복되도다 | 요한복음 20:24-29',
    videoId: 'zGIzV_NUp9w'
  },
  {
    date: '2026-04-05',
    title: '[얼바인중앙침례교회 부활주일 감사예배] 다 이루었다 | 고린도전서 15:55-57',
    videoId: '8BDLWgeFPTQ'
  },
  {
    date: '2026-03-29',
    title: '[얼바인중앙침례교회 주일예배] 진짜 왕을 모시는 사람들 | 요한복음 12:16',
    videoId: '1Ch-g-Oy6IA'
  },
  {
    date: '2026-03-22',
    title: '[얼바인중앙침례교회 주일예배] 십자가가 만든 새로운 인생 | 갈라디아서 6:1-5, 14-16',
    videoId: 'q1LR5rpitKE'
  },
  {
    date: '2026-03-15',
    title: '[얼바인중앙침례교회 주일예배] 하나님의 뜻을 구하는 인생은 혼자 애쓰는 삶이 아닙니다 | 갈라디아서 5:16-26',
    videoId: '5cf2i-XyGZo'
  },
  {
    date: '2026-03-08',
    title: '[얼바인중앙침례교회 주일예배] 다시는 종의 멍에를 메지 말라 | 갈라디아서 5:1-15',
    videoId: '1PYoyf3K7dU'
  },
  {
    date: '2026-03-01',
    title: '[얼바인중앙침례교회 주일예배] 다시 아버지를 부르는 자리 | 갈라디아서 4:6-7, 12-16',
    videoId: 'wbHwiJhfSts'
  },
  {
    date: '2026-02-22',
    title: '[얼바인중앙침례교회 주일예배] 우리가 얻을 기업 | 에베소서 1:11–14',
    videoId: 'vJW1oEWhKvE'
  },
  {
    date: '2026-02-08',
    title: '[얼바인중앙침례교회 주일예배] 성령으로 시작된 인생 | 갈라디아서 3:1–5',
    videoId: 'aCqifICPxaA'
  },
  {
    date: '2026-02-01',
    title: '[얼바인중앙침례교회 주일예배] 하나님의 뜻보다 사람의 시선이 앞설 때 | 갈라디아서 2:11–21',
    videoId: 'rMI9JlUVk5M'
  },
  {
    date: '2026-01-25',
    title: '[얼바인중앙침례교회 주일예배] 흔들려도 하나님 안에서 숨 쉬는 믿음 | 갈라디아서 2:1–8',
    videoId: 'jh1GIpUMSuA'
  },
  {
    date: '2026-01-18',
    title: '[얼바인중앙침례교회 주일예배] 내 인생에 들어온 복음 | 갈라디아서 1:11-17',
    videoId: 'LghQ-sCYxw8'
  },
  {
    date: '2026-01-11',
    title: '[얼바인중앙침례교회 주일예배] 하나님의 뜻과 사람의 뜻은 다릅니다 | 갈라디아서 1:6-10',
    videoId: '1t_mPOmO_1Q'
  },
  {
    date: '2026-01-04',
    title: '[얼바인중앙침례교회 주일예배] 하나님의 뜻을 구하여 하나님의 뜻이 이루어지는 인생 | 마태복음 6:33',
    videoId: 'kkjOl7Zg_Fw'
  },
  {
    date: '2025-12-28',
    title: '[얼바인중앙침례교회 주일예배/25.12.28] 한해를 돌아보며(히브리서 :10:23)',
    videoId: '0BU7jA00WtM'
  },
  {
    date: '2025-12-21',
    title: '[얼바인중앙침례교회 주일예배/25.12.21] 말씀이 육신이 되어 우리 가운데 거하신 은혜(요한복음 :1:9-14)',
    videoId: 'CJhSiM7nk_Y'
  },
  {
    date: '2025-12-14',
    title: '[얼바인중앙침례교회 주일예배/25.12.14] 여수룬아! 너는 행복한 사람이로다 (신명기 33:26-29)',
    videoId: 'V3Ol1phMyh8'
  },
  {
    date: '2025-12-07',
    title: '[얼바인중앙침례교회 주일예배/25.12.07] 하나님의 기적으로 살았던 백성들(신명기 32:7-12)',
    videoId: 'jHMq8xwZ-ok'
  },
  {
    date: '2025-11-30',
    title: '[얼바인중앙침례교회 주일예배/25.11.30] 너희는 강하고 담대하라(신명기 31:6-8)',
    videoId: '1QAyaljQ9pE'
  },
  {
    date: '2025-11-23',
    title: '[얼바인중앙침례교회 주일예배/추수감사주일] 우리에게 열매를 주시는 하나님 (하박국 3:17-19)',
    videoId: 'DzLrK0e2unk'
  },
  {
    date: '2025-11-16',
    title: '[얼바인중앙침례교회 주일예배/신명기 강해 21] 선택이 쌓여서 얻는 열매  (신명기 30:11-20)',
    videoId: 'c37pfV-dtF4'
  },
  {
    date: '2025-11-09',
    title: '[얼바인중앙침례교회 주일예배/신명기 강해 20]  믿음의 눈이 열릴 때 (신명기 29:2-6)',
    videoId: 'cKO42isWnDU'
  },
  {
    date: '2025-11-02',
    title: '[얼바인중앙침례교회 주일예배/창립4주년 감사예배]  교회 (마가복음 2:15-17)',
    videoId: 'Rr4K7tF6gWY'
  },
  {
    date: '2025-10-26',
    title: '[얼바인중앙침례교회 주일예배/신명기 강해 19]  우리는 누군가의 "복"입니다. (신명기 28:1-14)',
    videoId: 'UYyLuQpH3rc'
  },
  {
    date: '2025-10-19',
    title: '[얼바인중앙침례교회 주일예배/신명기 강해 18]  하나님께 드릴 열매 (신명기 26:1-11)',
    videoId: 'fpX_j0jKdnU'
  },
  {
    date: '2025-10-12',
    title: '[얼바인중앙침례교회 주일예배/신명기 강해 17]  아말렉을 기억하라 (신명기 25:17-19)',
    videoId: '-FoFSfBYLlY'
  },
  {
    date: '2025-10-05',
    title: '[얼바인중앙침례교회 주일예배/신명기 강해 16] 하나님의 편재성과 임재 (신명기 23:1-8,14)',
    videoId: '8AbBQFPO_q4'
  },
  {
    date: '2025-09-28',
    title: '[얼바인중앙침례교회 주일예배/신명기 강해 15] 신앙의 난간을 세워라 (신명기 22:8)',
    videoId: '8acxiI5SvfE'
  },
  {
    date: '2025-09-21',
    title: '[얼바인중앙침례교회 주일예배/신명기 강해 14] 대적과 싸울 때에 (신명기 20:1-9)',
    videoId: 'oTfZsnICeFA'
  },
  {
    date: '2025-09-14',
    title: '[얼바인중앙침례교회 주일예배/신명기 강해 13] 한 영혼을 세우는 공동체 법 (신명기 19:15-20)',
    videoId: 'Xc0gQgoPEoE'
  },
  {
    date: '2025-09-07',
    title: '[얼바인중앙침례교회 주일예배/신명기 강해 12] 너희는 그의 말을 들을지니라 (신명기 18:15-22)',
    videoId: 'vHvgEdz0U6g'
  },
  {
    date: '2025-08-31',
    title: '[얼바인중앙침례교회 주일예배/신명기 강해 11] 면제(Release) 규례의 4가지 실체 (신명기 15:1-2)',
    videoId: 'LG2fPTOqlIM'
  },
  {
    date: '2025-08-24',
    title: '[얼바인중앙침례교회 주일예배/신명기 강해 10] 말씀, 마음을 넘어 삶에 새기라 (신명기 11:18-21)',
    videoId: 'bNT0YVcXwXw'
  },
  {
    date: '2025-08-03',
    title: '[얼바인중앙침례교회 주일예배/신명기 강해 7]  왕벌을 보내시는 하나님  (신명기 7:17-24)',
    videoId: '2_PflPmKfNw'
  },
  {
    date: '2025-07-27',
    title: '[얼바인중앙침례교회 주일예배/신명기 강해 6]  매우 익숙한 본질 (신명기 6:1-9)',
    videoId: 'z5lk4qyWWGI'
  },
  {
    date: '2025-07-20',
    title: '[얼바인중앙침례교회 주일예배/신명기 강해 5]  새로운 말씀으로 다시 들어라 (신명기 5:1-6)',
    videoId: 'Vvpzbxr9JIs'
  },
  {
    date: '2025-07-13',
    title: '[얼바인중앙침례교회 주일예배/신명기 강해 4]  말씀, 더하지도 말고 빼지도 말라 (신명기 4:1-14)',
    videoId: 'ArC5NUcInUs'
  },
  {
    date: '2025-07-06',
    title: '[얼바인중앙침례교회 주일예배/신명기 강해 3]  복음을 말씀하시다 (신명기 3:23-29)',
    videoId: 'SDtDo7oUX10'
  },
  {
    date: '2025-06-29',
    title: '[얼바인중앙침례교회 주일예배/신명기 강해 2]  이제 은혜에 순종할 때 입니다. (신명기 2:1-9)',
    videoId: '8jtLYLEdWA8'
  },
  {
    date: '2025-06-22',
    title: '[IJBC 주일예배/신명기 강해 1]  광야 끝, 말씀으로 다시 시작 (신명기 1:29-33)',
    videoId: 'KKGijGsZZfU'
  },
  {
    date: '2025-06-15',
    title: '[IJBC 주일예배/성령강림주일]  아바 아버지 (로마서 8:14-15)',
    videoId: 'l-Qbz22buZE'
  },
  {
    date: '2025-06-08',
    title: '[IJBC 주일예배/성령강림주일]  성령님의 위대한 3가지 사역 (로마서 8:1-10)',
    videoId: 'rWRnhn-99Co'
  },
  {
    date: '2025-06-01',
    title: '[IJBC 주일예배]  하나님이 찾으시는 자 (에스겔 22:30-31, 마태복음 4:1-2)',
    videoId: 'kZ2BGx1ROmc'
  },
  {
    date: '2025-05-25',
    title: '[IJBC 주일예배/가정의 달 설교 4] 나를 기다리는 집 (요한복음 14:2-3)',
    videoId: '0l6bEjyOsv0'
  },
  {
    date: '2025-05-18',
    title: '[IJBC 주일예배/가정의 달 설교 3] 치유와 회복을 일으키는 힘 (에베소서 4:29)',
    videoId: 'l-lb8GF6pOU'
  },
  {
    date: '2025-05-11',
    title: '[IJBC 주일예배/가정의 달 설교 2] 빛과 소금의 자리 (마태복음 5:13-16)',
    videoId: 'a9075u5zIJg'
  },
  {
    date: '2025-05-04',
    title: '[IJBC 주일예배/가정의 달 설교 1] 하나님의 말씀으로 시작된 가정 창세기 2:18-24 #얼바인 #개혁주의 #한인교회 #건강한교회 #가정의회복',
    videoId: 'QDVxuJCCo1I'
  },
  {
    date: '2025-04-27',
    title: '[IJBC 주일예배] 경건의 마침표 (요한복음 21:21-22)',
    videoId: 'f2yVtTDwmv0'
  },
  {
    date: '2025-04-20',
    title: '[IJBC 부활절 주일예배] 큰 기쁨  (마태복음 28장 8절)',
    videoId: '2GCRFHYELwA'
  },
  {
    date: '2025-04-13',
    title: '[IJBC 주일예배] \'호산나\'와 \'십자가에 못 박으라!\'의 사이  (요한복음 12:12-19,19:15)',
    videoId: 'UgeNeOnzMZ4'
  },
  {
    date: '2025-04-06',
    title: '[IJBC 주일예배] 의심이라는 영적 질병  (요한복음 20:24-29)',
    videoId: '5448t4C74j4'
  },
  {
    date: '2025-03-30',
    title: '[IJBC 주일예배] 우리를 이끄시는 하나님의 작정  (창세기 25:23, 47:9)',
    videoId: 'gzqANsb8Rr0'
  },
  {
    date: '2025-03-16',
    title: '[IJBC 주일예배] 우리에게 믿을 수 없는 일이 일어납니다  (요한복음 17:9-26)',
    videoId: 'C1g_hbAfcMY'
  },
  {
    date: '2025-03-09',
    title: '[IJBC 주일예배] 하나님이 한 사람을 경건으로 이끄시다  (다니엘 6:1-10)',
    videoId: 'tS25yoSOFlk'
  },
  {
    date: '2025-03-02',
    title: '[IJBC 주일예배] 진리로 세상을 이기라  (요한복음 16:1-15)',
    videoId: 'bc6WWMW5R8k'
  },
  {
    date: '2025-02-23',
    title: '[IJBC 주일예배] 내 안에 거하라  (요한복음 15:1-12)',
    videoId: 'zN10SbJsHQE'
  },
  {
    date: '2025-02-16',
    title: '[IJBC 주일예배] 예수님이 가르쳐 주시는 경건의 삶  (요한복음 14:1-7, 21-31)',
    videoId: 'mkX1xKMvxO8'
  },
  {
    date: '2025-02-09',
    title: '[IJBC 주일예배] 경건을 위해 지켜야 할 것  (요한복음 13:21-38)',
    videoId: 'TcNmUq_ZBMU'
  },
  {
    date: '2025-01-26',
    title: '[IJBC 주일예배] 예수님이 제자들의 발을 씻기다 (요한복음 13:1-17)',
    videoId: 'rvWJ4iXTJPY'
  },
  {
    date: '2025-01-19',
    title: '[IJBC 주일예배] 참된 경건의 목적과 본질 (요한복음 12:21-33) / 2025.1.19 11:00 a.m',
    videoId: 'SA9yTHoBOyw'
  },
  {
    date: '2025-01-12',
    title: '[IJBC 주일예배] 참된 경건의 시작 (요한복음 12:1-8) / 2025.1.12 11:00 a.m',
    videoId: 'xvGtmY_SNX0'
  },
  {
    date: '2025-01-05',
    title: '[IJBC 주일예배] 이제 흠 없는 참된 경건으로 나아갑시다  (마태복음 5:16) / 2025.1.5 11:00 a.m',
    videoId: 'fGhrWeqGuJ8'
  },
  {
    date: '2024-12-29',
    title: '[IJBC 주일예배] 성도의 엔딩은 완주입니다. 히브리서 12:1-2 #얼바인 #개혁주의 #한인교회 #건강한교회',
    videoId: '1zl0X0tlsgY'
  },
  {
    date: '2024-12-22',
    title: '[IJBC 주일예배] (성탄절 감사예배) 성탄을 놓친 사람들/ 누가복음 2:1-20 #얼바인 #개혁주의 #한인교회 #건강한교회',
    videoId: 'U5BCBOjgUto'
  },
  {
    date: '2024-12-15',
    title: '[IJBC 주일예배] (요한복음 강해 20) 네가 믿으면 하나님의 영광을 보리라. 요한복음 11:20-40 #얼바인 #개혁주의 #한인교회 #건강한교회',
    videoId: 'wJgcwnQV7vI'
  },
  {
    date: '2024-12-08',
    title: '[IJBC 주일예배] (요한복음 강해 19) 그들은 예수님의 말씀을 싫어합니다. 요한복음 10:19-33 #얼바인 #개혁주의 #한인교회 #건강한교회',
    videoId: 'Aw8NciiszgE'
  },
  {
    date: '2024-12-01',
    title: '[IJBC 주일예배] (요한복음 강해 18) 나는 "양"입니다. 요한복음 10:1-15 #얼바인 #개혁주의 #한인교회 #건강한교회',
    videoId: '-rENL6lFzFM'
  },
  {
    date: '2024-11-24',
    title: '[IJBC 추수감사주일예배] 감사로 회복되는 삶. 골로새서 3:15-17 #얼바인 #개혁주의 #한인교회 #건강한교회',
    videoId: '5CuRA8g2p_Q'
  },
  {
    date: '2024-11-17',
    title: '[IJBC 주일예배] (요한복음 강해 17) 예수님을 만나 두 번 눈을 뜨다. 요한복음 9:1-33 #얼바인 #개혁주의 #한인교회 #건강한교회',
    videoId: 'pRPLqtF2R_M'
  },
  {
    date: '2024-11-10',
    title: '[IJBC 주일예배] (요한복음 강해 16) 진리가 너희를 자유케 하리라 요한복음 8:31 - 45 #얼바인 #개혁주의 #한인교회 #건강한교회',
    videoId: '7UGg_YPELvc'
  },
  {
    date: '2024-11-03',
    title: '[IJBC 주일예배] (3주년 감사예배) 네 직무를 다하라. 디모데후서 4:1-5 #얼바인 #개혁주의 #한인교회 #건강한교회',
    videoId: 'ZGcmMk0i164'
  },
  {
    date: '2024-10-27',
    title: '[IJBC 주일예배] (요한복음 강해 15) 돌을 든 자리와 돌을 맞는 자리 요한복음 7:53 - 8:11 #얼바인 #개혁주의 #한인교회 #건강한교회',
    videoId: 'eGu1RS_tQrU'
  },
  {
    date: '2024-10-20',
    title: '[IJBC 주일예배] (요한복음 강해 13) 변화의 강물, 은혜의 강 요한복음 7:37-39 #얼바인 #개혁주의 #한인교회 #건강한교회',
    videoId: 'W12eT_frMEw'
  },
  {
    date: '2024-10-13',
    title: '[IJBC 주일예배] (요한복음 강해 13) 하나님의 뜻을 알기 원합니다 요한복음 7:1-24 #얼바인 #개혁주의 #한인교회 #건강한교회',
    videoId: 'kERCffjzoAE'
  },
  {
    date: '2024-10-06',
    title: '[IJBC 주일예배] (요한복음 강해 13) 많은 사람들이 떠나간 설교 요한복음 6:35-66 #얼바인 #개혁주의 #한인교회 #건강한교회',
    videoId: '3zh7Y6Z4hK0'
  },
  {
    date: '2024-09-29',
    title: '[IJBC 주일예배] 하반기 말씀집회 회복(Restore) 시편 51:12 #얼바인 #개혁주의 #한인교회 #건강한교회',
    videoId: 'QD3nx_pKX7w'
  },
  {
    date: '2024-09-22',
    title: '[IJBC 주일예배] (요한복음 강해 12) 예수님을 만난 나의 믿음 요한복음 6:1-15 #얼바인 #개혁주의 #한인교회 #건강한교회',
    videoId: 'i2_CytTj3eM'
  },
  {
    date: '2024-09-15',
    title: '[IJBC 주일예배] (요한복음 강해 11) 말씀이 그 속에 있는 자들 요한복음 5:31-47 #얼바인 #개혁주의 #한인교회 #건강한교회',
    videoId: '9QKK6UMUDm8'
  },
  {
    date: '2024-09-08',
    title: '[IJBC 주일예배] (요한복음 강해 10) 하나님의 일, 회복 요한복음 5:1-17 #얼바인 #개혁주의 #한인교회 #건강한교회',
    videoId: 'VMhfm2QPdyU'
  },
  {
    date: '2024-09-01',
    title: '[IJBC 주일예배] 영성이 있는 교회 / 마태복음  14:24-32 / 강대혁 목사(새에덴 교회 원로) #얼바인 #개혁주의 #한인교회 #건강한교회',
    videoId: 'sCXZGuOfyEk'
  },
  {
    date: '2024-08-25',
    title: '[IJBC 주일예배] 예수님을 믿으라 / 요한복음 4:39-54 / 정성택 목사 #얼바인 #개혁주의 #한인교회 #건강한교회#요한복음',
    videoId: 'j7rx2tYkxcM'
  },
  {
    date: '2024-08-18',
    title: '[IJBC 주일예배] 기적의 예수가 지나가신다 / 마태복음 20:29-34 / 안병국 목사 (뉴욕 웨체스터 제일교회) #얼바인 #개혁주의 #한인교회 #건강한교회#요한복음',
    videoId: 'xHWFZIgStUE'
  },
  {
    date: '2024-08-11',
    title: '[IJBC 주일예배] 요한복음 강해8  믿음의 눈이 열리는 은혜 / 요한복음 4:3-30 / 정성택 목사 #얼바인 #개혁주의 #한인교회 #건강한교회#요한복음',
    videoId: 'Ej8TMKPxIjU'
  },
  {
    date: '2024-08-04',
    title: '[IJBC 주일예배] 요한복음 강해7  나는 죽고 오직 예수로 살고 / 요한복음 3:22-36 / 정성택 목사 #얼바인 #개혁주의 #한인교회 #건강한교회#요한복음',
    videoId: '9XK2BCT0s2M'
  },
  {
    date: '2024-07-28',
    title: '[IJBC 주일예배] 요한복음 강해6  니고데모의 신앙 / 요한복음 3:1-21 / 정성택 목사 #얼바인 #개혁주의 #한인교회 #건강한교회#요한복음',
    videoId: 'ncNsRS2eGNM'
  },
  {
    date: '2024-07-21',
    title: '[IJBC 주일예배] 요한복음 강해5 - 성전을 향하신 예수님의 마음 / 요한복음 2:13-22 / 정성택 목사 #얼바인 #개혁주의 #한인교회 #건강한교회#요한복음',
    videoId: 'S9uEpknwrEk'
  },
  {
    date: '2024-07-14',
    title: '[IJBC 주일예배] 변화의 기적/ 요한복음 2:1-11 / 정성택 목사 #얼바인 #개혁주의 #한인교회 #건강한교회#요한복음',
    videoId: 'ttv2sP09Jfc'
  },
  {
    date: '2024-07-07',
    title: '[IJBC 주일예배] 예수님을 만나다/ 요한복음 1: 43-51 / 정성택 목사 #얼바인 #개혁주의 #한인교회 #건강한교회#요한복음',
    videoId: 'sCZklyMAFgs'
  },
  {
    date: '2024-06-30',
    title: '[IJBC 주일예배] 오직 예수님만 드러내는 삶 / 요한복음 1: 6-8,19-23 / 정성택 목사 #얼바인 #개혁주의 #한인교회 #건강한교회#요한복음',
    videoId: 'k-3m1xt_-7Y'
  },
  {
    date: '2024-06-23',
    title: '[IJBC 주일예배] 예수님은 말씀이십니다. 요한복음 1: 1-3 / 정성택 목사 #얼바인 #개혁주의 #한인교회 #건강한교회#요한복음',
    videoId: 'zKwOUEP1SJE'
  },
  {
    date: '2024-06-16',
    title: '[IJBC 주일예배] 영적 싸움에서 승리하십시오  에베소서 6: 11-12 / 정성택 목사 #얼바인 #개혁주의 #한인교회 #건강한교회#요한일서',
    videoId: 'Kj9aK8za2bw'
  },
  {
    date: '2024-06-09',
    title: '[IJBC 주일예배] 이제 기도로 세상을 이기십시오 요한일서 5: 14-21 / 정성택 목사 #얼바인 #개혁주의 #한인교회 #건강한교회#요한일서',
    videoId: 'XwUCNEV-Wp0'
  },
  {
    date: '2024-06-02',
    title: '[IJBC 주일예배] 요한일서의 목적 "영생이 있음을 아십니까?" 요한일서 5: 6-13 / 정성택 목사 #얼바인 #개혁주의 #한인교회 #건강한교회#요한일서',
    videoId: 'R9-M0jiVVVw'
  },
  {
    date: '2024-05-26',
    title: '[IJBC 주일예배] "성공"이 아니라 "승리" 입니다 요한일서 5:1-5 / 정성택 목사 #얼바인 #개혁주의 #요한일서 #한인교회 #건강한교회',
    videoId: 'wtO2l5fnRIM'
  },
  {
    date: '2024-05-19',
    title: '[IJBC 주일예배] 건강한 가족, 건강한 교회 히브리서 10:23-25 / 정성택 목사 #얼바인 #개혁주의 #온라인헌금',
    videoId: 'l83_MfW1fEA'
  },
  {
    date: '2024-05-12',
    title: '[IJBC 가정의 달 주일 특별예배] 축복된 가정 창세기 2:26 / 박승빈 목사 #얼바인 #개혁주의 #온라인헌금',
    videoId: 'XvBSOoev8dQ'
  },
  {
    date: '2024-05-05',
    title: '[IJBC 주일예배] 사랑을 위해 기도하라 요한일서 4:9-21 / 정성택 목사 #얼바인 #개혁주의 #온라인헌금',
    videoId: 'vi1dYTkrvRs'
  },
  {
    date: '2024-04-28',
    title: '[IJBC 주일예배] 성육신을 믿는 참 믿음 요한일서 4:1-8 / 정성택 목사 #얼바인 #개혁주의 #온라인헌금',
    videoId: 'CVTI_7jhtl8'
  },
  {
    date: '2024-04-21',
    title: '[IJBC 주일예배] 하나님의 자녀는 드러납니다 요한일서 3:10-20 / 정성택 목사 #얼바인 #개혁주의 #온라인헌금',
    videoId: 'VJ5ytQ-LfqU'
  },
  {
    date: '2024-04-14',
    title: '[IJBC 주일예배] 완전한 거룩함을 향한 열심 요한일서 3:1-9 / 정성택 목사 #얼바인 #개혁주의 #온라인헌금',
    videoId: '5_59qsEKGcI'
  },
  {
    date: '2024-04-07',
    title: '[IJBC 주일예배] 가르치신 그대로 주 안에 거하라 요한일서 2:12-29 / 정성택 목사 #얼바인 #개혁주의 #온라인헌금',
    videoId: 'YQCzJ4Ty1f4'
  },
  {
    date: '2024-03-31',
    title: '[IJBC 부활주일예배] 그리스도의 부활을 따라서 골로새서 3:1-4 / 정성택 목사 #얼바인 #개혁주의 #온라인헌금',
    videoId: '7DrPellLWfY'
  },
  {
    date: '2024-03-24',
    title: '[IJBC 주일예배] 우리는 왜 그리스도의 고난을 기억해야 할까요? 히브리서 12:1-3 / 정성택 목사 #얼바인 #개혁주의 #온라인헌금',
    videoId: 'kH0Adh6CoOg'
  },
  {
    date: '2024-03-17',
    title: '[IJBC 주일예배] 은혜 위에 은혜 요한복음 1:17-18 / 정성택 목사 #얼바인 #개혁주의 #온라인헌금',
    videoId: '4BHUMCpyvqc'
  },
  {
    date: '2024-03-10',
    title: '[얼바인중앙침례교회 부흥성회-주일예배]  알게되면 또한 보게 되리라-은사를 알면 상급이 보입니다. / 최병락 목사 / 2024.03.10. AM 11:00',
    videoId: '2pUlSmBlmj0'
  },
  {
    date: '2024-03-03',
    title: '[IJBC 주일예배] 참 빛이 우리를 비추었습니다 요한일서 2:7-11 / 정성택 목사 #얼바인 #개혁주의 #주일예배',
    videoId: '_ojTcGRq7Qw'
  },
  {
    date: '2024-02-25',
    title: '[IJBC 주일예배] 저를 아는 자 요한일서 2:1-6 / 정성택 목사 #얼바인 #개혁주의 #주일예배',
    videoId: 'o8ySDcluiNY'
  },
  {
    date: '2024-02-18',
    title: '[IJBC 주일예배] 사귐을 위해 빛 가운데 행하라 요한일서 1:5-10 / 정성택 목사 #얼바인 #개혁주의 #주일예배',
    videoId: '6eUn8KoH_6Y'
  },
  {
    date: '2024-02-11',
    title: '[IJBC 주일예배] 주님과 깊이 사귀고 계십니까 요한일서 1:1-4 / 정성택 목사 #얼바인 #개혁주의 #주일예배',
    videoId: 'HTOwfuLFAi0'
  },
  {
    date: '2024-02-04',
    title: '[IJBC 주일예배] 성령이 이끄시는 말 (혀의 실체) 야고보서 3:1-10 / 정성택 목사 #얼바인 #개혁주의 #주일예배',
    videoId: 'BJInyzjSI5s'
  },
  {
    date: '2024-01-28',
    title: '[IJBC 주일예배] 성령님의 역사 고린도전서 3:16 / 정성택 목사 #얼바인 #개혁주의 #주일예배',
    videoId: 'LBheJpSaSaI'
  },
  {
    date: '2024-01-21',
    title: '[IJBC 주일예배] 성령님이 이끄시는 교제/ 에베소서 6:5-8 / 정성택 목사 #얼바인 #개혁주의 #주일예배',
    videoId: 'n2KdyhK91Bs'
  },
  {
    date: '2024-01-14',
    title: '[IJBC 주일예배]성령의 하나되게 하신 것을 힘써 지키라 / 에베소서 4:1-6 / 정성택 목사 #얼바인 #개혁주의 #주일예배',
    videoId: 'viI17G4vBjk'
  },
  {
    date: '2024-01-07',
    title: '[IJBC 주일예배]지체는 많으나 몸은 하나라 / 고린도전서 12:12-20 / 정성택 목사 #얼바인 #개혁주의 #주일예배',
    videoId: 'QbpZ1vG-Gac'
  },
  {
    date: '2023-12-31',
    title: '[주일설교] 교회를 세우시는 주님 시리즈 44 / "교회" 그리고 "하나님 나라"(행 28:20-31) / 정성택 목사 #얼바인 #개혁주의 #한인교회 #침례교회 #사도행전',
    videoId: 'BtpFhackL7U'
  },
  {
    date: '2023-12-24',
    title: '[IJBC 주일예배] 성탄감사예배 - 동정녀 탄생의 이유 /마태복음 1:18-25 / 정성택 목사 #얼바인 #개혁주의 #동정녀 탄생 #성탄설교',
    videoId: 'Y_I4_nY4hyE'
  },
  {
    date: '2023-12-17',
    title: '[주일설교] 교회를 세우시는 주님 시리즈 42 / 하나님의 부르심이 나의 문제가 될 때 (행 24:22-27) / 정성택 목사 #얼바인 #개혁주의 #한인교회 #침례교회 #사도행전',
    videoId: 'fsP30kOJhZo'
  },
  {
    date: '2023-12-10',
    title: '[IJBC 주일설교] 사도행전 강해 (교회를 세우시는 주님 시리즈 41) / 교회를 은혜의 말씀께 맡겨드립니다. / 사도행전 20:22-38 / 정성택 목사',
    videoId: 's7qhUj_zLS0'
  },
  {
    date: '2023-12-03',
    title: '[IJBC 주일예배]  교회를 세우시는 주님 40 - 내 안에 들어오신 하나님 /사도행전 19장 1-20절/ 정성택 목사  #얼바인 #개혁주의 #한인교회  #침례교회',
    videoId: 'HNx4MQn-GIk'
  },
  {
    date: '2023-11-26',
    title: '[IJBC 주일예배]  교회를 세우시는 주님 39 - 바울에게 주신 고린도라는 축복 /사도행전 18장 / 정성택 목사  #얼바인 #개혁주의 #한인교회  #침례교회',
    videoId: 'F4fQ_wEIcYg'
  },
  {
    date: '2023-11-19',
    title: '[IJBC 주일예배]  추수감사절-감사를 지켜라 /신명기 16:13-`7/ 강신정 목사(논산한빛교회)  #얼바인 #개혁주의 #한인교회  #침례교회',
    videoId: 'Y3T9ToEponU'
  },
  {
    date: '2023-11-12',
    title: '[IJBC 주일예배]  교회를 세우시는 주님 38 - 오늘날 교회가 잃어가는 것들 /사도행전 17장 / 정성택 목사  #얼바인 #개혁주의 #한인교회  #침례교회',
    videoId: 'EhRzBo11A0g'
  },
  {
    date: '2023-10-29',
    title: '[IJBC 주일예배]  REMEMBRANCE "기억" /신명기 32:7-12 / 정성택 목사  #얼바인 #개혁주의 #한인교회  #신명기 #기억 #기념 #침례교회',
    videoId: 'DKvlwTnoUhU'
  },
  {
    date: '2023-10-22',
    title: '[IJBC 주일예배] 교회를 세우시는 주님 37 - 기도로 인생을 세우십시오. /사도행전 16:6-15 / 정성택 목사 #사도행전강해 #얼바인 #교회 #개혁주의  #기도 #빌립보',
    videoId: 'pD5Ai2m3tWQ'
  },
  {
    date: '2023-10-15',
    title: '[IJBC 주일예배] 교회를 세우시는 주님 36 - 교회는 본질을 잊지 말아야 합니다 /사도행전 15:1-11 / 정성택 목사 #사도행전강해 #얼바인 #교회 #개혁주의  #본질',
    videoId: 'k55li8WZxl4'
  },
  {
    date: '2023-10-08',
    title: '[IJBC 주일예배] 교회를 세우시는 주님  35 - 믿음의 실제 (의지하고 순종하라) /사도행전 14:19-28 / 정성택 목사 #사도행전강해 #얼바인 #교회 #믿음 #순종',
    videoId: 'nLQHuGGxTm0'
  },
  {
    date: '2023-10-01',
    title: '[IJBC 주일예배] 교회를 세우시는 주님  34-오직 하나님께 영광을(솔리 데오 글로리아) /사도행전 14:1-15 / 정성택 목사 #사도행전강해 #얼바인 #교회',
    videoId: 'jUXWN26MQu4'
  },
  {
    date: '2023-09-24',
    title: '[IJBC 주일에배] 교회를 세우시는 주님  33-주 안에서 좌절은 없습니다. 선하신 뜻이 있을 뿐입니다. /사도행전 13:42-52 / 정성택 목사 #사도행전강해 #얼바인',
    videoId: 'bQBd6hRpNvE'
  },
  {
    date: '2023-09-17',
    title: '[IJBC주일예배] 교회를 세우시는 주님 32- 예수를 아십니까? / 사도행전 13:16-27 / 정성택 목사  #개혁주의  #사도행전강해 #얼바인',
    videoId: 'Oe86WyiQmz4'
  },
  {
    date: '2023-09-10',
    title: '[IJBC주일예배전체] 교회를 세우시는 주님 31 - 그리스도 안에서 실패자는 없습니다. / 사도행전 13:4-5, 13 / 정성택 목사 #개혁주의  #사도행전강해 #얼바인',
    videoId: 'YFaQ-gZ5J6o'
  },
  {
    date: '2023-09-03',
    title: '[IJBC주일예배전체] 교회를 세우시는 주님 30 - 성령님의 권세와 능력 / 사도행전 13:6-12 / 정성택 목사 / 개혁주의',
    videoId: 'nC2I4UUQWOE'
  },
  {
    date: '2023-08-27',
    title: '[IJBC주일예배설교] 교회를 세우시는 주님 29 - 성령의 인도를 따라 / 사도행전 13:1-12 / 정성택 목사 / 개혁주의',
    videoId: '-a4MLKocKc8'
  },
  {
    date: '2023-08-20',
    title: '[IJBC주일예배설교] 교회를 세우시는 주님 28 - 하나님의 큰 일이 시작되기 전에 / 사도행전 12:18-24 / 정성택 목사 / 개혁주의',
    videoId: 'arj6ECPIegY'
  },
  {
    date: '2023-08-13',
    title: '[IJBC주일예배설교] 교회를 세우시는 주님 27 - 교회의 기도 / 사도행전 12:1-16 / 정성택 목사 / 개혁주의',
    videoId: '8mn545VoyXI'
  },
  {
    date: '2023-08-06',
    title: '[IJBC주일예배전체] 교회를 세우시는 주님 26 -왜 안디옥 교회인가요? / 사도행전 11:19-30 / 정성택 목사 / 개혁주의',
    videoId: '9H_OG_yEGTE'
  },
  {
    date: '2023-07-30',
    title: '[IJBC주일예배설교] 교회를 세우시는 주님 25 -누가 하나님을 능히 막겠느냐 / 사도행전 11:1-18 / 정성택 목사 / 개혁주의',
    videoId: 'PKyad7tAFKo'
  },
  {
    date: '2023-07-23',
    title: '[IJBC주일예배설교] 교회를 세우시는 주님 24 -구별하신 만남/ 사도행전 10:24-25 / 정성택 목사 / 개혁주의',
    videoId: 'bjmbPUhSP-g'
  },
  {
    date: '2023-07-16',
    title: '[IJBC주일예배전체] 교회를 세우시는 주님 23 -베드로의 큰 실수/ 사도행전 10:9-16 / 정성택 목사 / 개혁주의',
    videoId: 'VNxhjOXR5xM'
  },
  {
    date: '2023-07-09',
    title: '[IJBC주일예배전체] 우리는 무엇을 심고 있나요? / 시편 126편 6절 / 정성택 목사 / 개혁주의',
    videoId: 'DMTnrj5zVXA'
  },
  {
    date: '2023-06-04',
    title: '[IJBC 주일예배] 사도행전 강해 18.교회를 파괴하는 자, 교회를 세우는 자 / 사도행전 8:1-8 / 정성택 목사 / 개혁주의',
    videoId: 'DdLGuWR-Ljs'
  },
  {
    date: '2023-05-28',
    title: '[IJBC 주일예배] 사도행전 강해 17. 스데반 설교에 나타난 복음 / 사도행전 7:2-10 / 정성택 목사 / 개혁주의',
    videoId: 'Fv9vMzytcfU'
  },
  {
    date: '2023-05-21',
    title: '[IJBC 주일예배] 사도행전 강해 16. 스데반의 죽음이 주는 메시지 / 사도행전 7:51-60 / 정성택 목사/ 개혁주의',
    videoId: 'QOin9RQNHiY'
  },
  {
    date: '2023-05-14',
    title: '[IJBC얼바인중앙침례교회] 가정의 달 주일 야외예배 / 가정의 평안 (시편 127편) / 박승빈 목사 / 2023.5.14.',
    videoId: 'wuzDfxdTRyQ'
  },
  {
    date: '2023-05-07',
    title: '[IJBC 주일예배] 사도행전 강해 15. 천사와 같은 얼굴 (사도행전 6장 8-15절) / 정성택 목사 / / 개혁주의',
    videoId: 'JPUzoVGQ1-8'
  },
  {
    date: '2023-04-30',
    title: '[IJBC 주일예배] 사도행전 강해 14. 교회는 변화가 있습니다./ 사도행전 6:7 / 정성택 목사',
    videoId: 'DSP0S8LMMzA'
  },
  {
    date: '2023-04-23',
    title: '[IJBC 주일예배] 사도행전 강해 13. 교회는 영적인 가족입니다 / 사도행전 6:1-6 / 정성택 목사',
    videoId: 'vUX-halo-yo'
  },
  {
    date: '2023-04-16',
    title: '[IJBC 주일예배] 사도행전 강해 12. 교회 메시지에 대한 3가지 반응 / 사도행전 5:33-42 / 정성택 목사',
    videoId: 'yUwtniFXOMc'
  },
  {
    date: '2023-04-09',
    title: '[IJBC 부활주일예배] 빈 무덤에 남기신 것들 / 누가복음 24:5-6 / 정성택 목사',
    videoId: 'XgGpppEnuwg'
  },
  {
    date: '2023-04-02',
    title: '[IJBC 주일예배]  십자가에 달리신 예수님  / 고린도전서 1:18-25 / Dr. James Song',
    videoId: 'tiq-ppOLUBI'
  },
  {
    date: '2023-03-26',
    title: '[IJBC 주일예배] 사도행전 강해 11. 교회의 메시지 1.(메시지의 권위) / 사도행전 5:12-32 / 정성택 목사',
    videoId: 'RsgcJk4-oY4'
  },
  {
    date: '2023-03-19',
    title: '[IJBC 주일예배] 사도행전 강해 10. 교회의 보이지 않는 실체 / 사도행전 5:1-11 / 정성택 목사',
    videoId: 'chZqtdK5AeE'
  },
  {
    date: '2023-03-12',
    title: '[IJBC 주일예배] 사도행전 강해 9. 빌기를 다하매(능력과 은혜) / 사도행전 4:29-33 / 정성택 목사',
    videoId: 'yxb2E8YeZTc'
  },
  {
    date: '2023-03-05',
    title: '[IJBC 주일예배] 사도행전 강해 8. 하나님 앞에서 판단하라 / 사도행전 4:15-21 / 정성택 목사',
    videoId: 'gZK8JiGT7xY'
  },
  {
    date: '2023-02-26',
    title: '[IJBC 주일예배] 사도행전 강해 7. 다시 시작된 시험 / 사도행전 4:1-10 / 정성택 목사',
    videoId: 'wuNXnAhT0u8'
  },
  {
    date: '2023-02-19',
    title: '[IJBC 주일예배] 사도행전 강해 6. 왜 우리를 주목하느냐? / 사도행전 3:11-16 / 정성택 목사',
    videoId: 'wN6Wc5S_8Qw'
  },
  {
    date: '2023-02-12',
    title: '[IJBC 주일예배] 사도행전 강해 5. 나면서부터 앉은뱅이였던 자 / 사도행전 3:1-10 / 정성택 목사',
    videoId: '73PYFFBUhzo'
  },
  {
    date: '2023-02-05',
    title: '[IJBC 주일예배] 사도행전 강해 4. 오순절 성령강림 후 첫 번째 설교 / 사도행전 2:14-21 / 정성택 목사',
    videoId: 'BEPCuAZUI-Q'
  },
  {
    date: '2023-01-29',
    title: '[IJBC 주일예배] 사도행전 강해 3. 오순절 성령강림 사건의 목적 / 사도행전 2:1-4 / 정성택 목사',
    videoId: 'GuZCcgmcLU4'
  },
  {
    date: '2023-01-22',
    title: '[IJBC 주일예배] 사도행전 강해 2. 예수님의 승천사건 (어찌하여 서서 하늘을 쳐다보느냐) / 사도행전 1:6-11 / 정성택 목사',
    videoId: '34YpiH5GHIE'
  },
  {
    date: '2023-01-15',
    title: '[IJBC 주일예배] 사도행전 강해 1. 유일한 희망: 교회입니다. / 사도행전 1:1-3 / 정성택 목사',
    videoId: '5ai3DwsoHoc'
  },
  {
    date: '2023-01-08',
    title: '[IJBC 주일예배] 우리는 예배자입니다. / 요한복음 4:19-24 / 정성택 목사',
    videoId: 'cVY9L9QembM'
  },
  {
    date: '2023-01-01',
    title: '[IJBC 주일예배] 2023년 교회 표어 : 그리스도의 몸을 함께 세워라 / 에베소서 1:23, 2:20-23 / 정성택 목사',
    videoId: 's1YHN_UR-qw'
  },
  {
    date: '2022-12-25',
    title: '[IJBC] 얼바인중앙침례교회 성탄절 주일예배 2022.12.25',
    videoId: '9KLvI6DIMIg'
  },
  {
    date: '2022-12-18',
    title: '[IJBC] 얼바인중앙침례교회 주일예배 2022.12.18',
    videoId: 'x4r0dYwfxuE'
  },
  {
    date: '2022-12-11',
    title: '[IJBC] 얼바인중앙침례교회 주일예배 2022.12.11',
    videoId: '1ZB8X875VGk'
  },
  {
    date: '2022-12-04',
    title: '[IJBC] 얼바인중앙침례교회 주일예배 2022.12.04',
    videoId: 'QAFsZ-j6wks'
  },
  {
    date: '2022-11-27',
    title: '[IJBC] 얼바인중앙침례교회 주일예배 2022.11.27',
    videoId: 'NiZ7pZycMUw'
  },
  {
    date: '2022-11-20',
    title: '[IJBC] 얼바인중앙침례교회 주일예배 2022.11.20',
    videoId: '6wErXiaG7wI'
  },
  {
    date: '2022-11-13',
    title: '[IJBC] 얼바인중앙침례교회 주일예배 2022.11.13',
    videoId: 'aoexhiedAZg'
  },
  {
    date: '2022-11-06',
    title: '[IJBC 주일예배] 베드로전서강해 8. 거듭남 (You must be born again) / 벧전 1:22-25 / 정성택 목사',
    videoId: 'f098qyMbo-I'
  },
  {
    date: '2022-10-30',
    title: '[IJBC 주일예배] 베드로전서강해 7. 거룩한 삶에 대한 동기부여 / 벧전 1:17-21 / 정성택 목사',
    videoId: '8HMHXJ8Sa8c'
  },
  {
    date: '2022-10-23',
    title: '[IJBC 주일예배] 베드로전서강해 6. 고난 속에서 거룩하라(거룩한 삶을 위한 7가지 습관) / 벧전 1:13-16 / 정성택 목사',
    videoId: 'VrtmBsfN4Vs'
  },
  {
    date: '2022-10-16',
    title: '[IJBC 주일예배] 베드로전서강해 5. 성도가 가진 특권의 크기 / 벧전 1:10-12 / 정성택 목사',
    videoId: '3kftCiQYUxM'
  },
  {
    date: '2022-10-02',
    title: '[IJBC 주일예배] 베드로전서강해 4. 고난 속에서 빛나는 믿음 / 벧전 1:6-9 / 정성택 목사',
    videoId: 'O1Dp029DaFw'
  },
  {
    date: '2022-09-25',
    title: '[IJBC 주일예배] 베드로전서강해 3. 산 소망 (Living Hope) / 벧전 1:3 / 정성택 목사',
    videoId: 'z9bxfWoT5aw'
  },
  {
    date: '2022-09-18',
    title: '[IJBC 주일예배] 베드로전서 강해 2. 택함받은 나그네 / 벧전 1:1-2 / 정성택 목사',
    videoId: 'wSLXncHaTS0'
  },
  {
    date: '2022-09-11',
    title: '[IJBC 주일예배] 베드로전서강해 1. 기대 (expectation) / 벧전 1:1-2 / 정성택 목사',
    videoId: '0c3JDGLorBM'
  },
  {
    date: '2022-08-28',
    title: '[IJBC 얼바인중앙침례교회] 팔복강해 8. 진리를 따라 화평케 하라 (마태복음 5:9) / 정성택 목사 / 주일예배 2022.08.28 #얼바인 #한인교회 #팔복강해 #개혁주의',
    videoId: 'fghgnwra_3k'
  },
  {
    date: '2022-08-14',
    title: '[IJBC 주일예배] 팔복강해 6. 오직 은혜로 긍휼함을 받은 성도 (마태복음 5:7) / 정성택 목사 / 2022.08.14. #얼바인 #한인교회 #개혁주의 #팔복강해',
    videoId: 'PzIZg_MUE4M'
  },
  {
    date: '2022-08-07',
    title: '[IJBC]얼바인중앙침례교회] 팔복강해 5. 의를 갈급해 하는 자 (마태복음 5:6) / 정성택 목사 /  주일예배 2022.08.07 얼바인 #개혁주의 #팔복강해 #한인교회',
    videoId: '564iGquRImg'
  },
  {
    date: '2022-07-31',
    title: '[IJBC] 얼바인중앙침례교회 주일예배 2022.7.31.',
    videoId: 'UK7iARnXqso'
  },
  {
    date: '2022-07-24',
    title: '[IJBC 얼바인중앙침례교회] 팔복강해 4. 누가 온유한 자인가? (마태복음 5:5) / 정성택 목사  주일예배 2022.07.24 #한인교회 #개혁주의 #얼바인 #팔복강해',
    videoId: 'ygkLPovv_jo'
  },
  {
    date: '2022-07-17',
    title: '[IJBC] 얼바인중앙침례교회 주일예배 2022.07.17',
    videoId: 'KTS2KqAwv7w'
  },
  {
    date: '2022-07-10',
    title: '[IJBC] 얼바인중앙침례교회 주일예배 2022.07.10',
    videoId: '7ugHGdesX2o'
  },
  {
    date: '2022-07-03',
    title: '[IJBC 얼바인중앙침례교회] 팔복강해 3. 무엇을 애통해야 하는가? (마태복음 5:4) / 정성택 목사 / 주일예배 2022.07.03 #한인교회 #팔복강해 #개혁주의 #얼바인',
    videoId: 'GwryIGbxBQQ'
  },
  {
    date: '2022-06-26',
    title: '[IJBC 얼바인중앙침례교회] 팔복강해 2. 누가 심령이 가난한 자인가? 마태복음 5:3 / 정성택 목사 /  2022.06.26 주일예배 #팔복강해 #한인교회 #개혁주의 #얼바인',
    videoId: 'c0CJ-DsVXIA'
  },
  {
    date: '2022-06-19',
    title: '[IJBC 얼바인중앙침례교회] 팔복강해 1. 팔복에 나타난 공통적인 특징 (마태복음 5:1-12)/ 정성택 목사 / 2022.06.19 주일예배',
    videoId: 'i72Jy6zDD_g'
  },
  {
    date: '2022-06-12',
    title: '[IJBC] 얼바인중앙침례교회 2022.06.12 주일예배',
    videoId: '4aiz4xKU9-c'
  },
  {
    date: '2022-06-05',
    title: '[IJBC] 얼바인중앙침례교회 2022.06.05 주일예배',
    videoId: 'HiBvv_Fichk'
  },
  {
    date: '2022-05-29',
    title: '[IJBC] 얼바인중앙침례교회 2022.05.29 주일예배',
    videoId: '3-d31UDUIPk'
  },
  {
    date: '2022-05-22',
    title: '[IJBC] 얼바인중앙침례교회 2022.05.22  주일예배',
    videoId: 'nBydmq7Yi10'
  },
  {
    date: '2022-05-15',
    title: '[IJBC] 얼바인중앙침례교회 2022.05.15  주일예배',
    videoId: 'evfFh-Vjfuw'
  },
  {
    date: '2022-05-08',
    title: '[IJBC] 얼바인중앙침례교회 2022.05.08  주일예배',
    videoId: '6UJI9jK3qPU'
  },
  {
    date: '2022-05-01',
    title: '[IJBC] 얼바인중앙침례교회 2022.05.01 주일예배',
    videoId: 'C06roVqbJtc'
  },
  {
    date: '2022-04-24',
    title: '[IJBC] 얼바인중앙침례교회 2022.04.24 주일예배',
    videoId: 'wxSz8xXrrVk'
  },
  {
    date: '2022-04-17',
    title: '[IJBC] 얼바인중앙침례교회 2022.04.17 주일예배/ 부활절 감사예배',
    videoId: 'W628T8jlxk0'
  },
  {
    date: '2022-04-10',
    title: '[IJBC] 얼바인중앙침례교회 2022.04.10  주일예배 / 그러므로 굳게 서라',
    videoId: '4fWwRKO8xY0'
  },
  {
    date: '2022-04-03',
    title: '[IJBC] 얼바인중앙침례교회 2022.04.03  주일예배',
    videoId: 'b5g8QSpJ-0M'
  },
  {
    date: '2022-03-27',
    title: '[IJBC] 얼바인중앙침례교회 2022.03.27  주일예배',
    videoId: 'OywUEljEYiw'
  },
  {
    date: '2022-03-20',
    title: '[IJBC] 얼바인중앙침례교회 2022.03.20  주일예배 / 하나님의 뜻을 아는 일에 관하여',
    videoId: '2dFwyl3YfSg'
  },
  {
    date: '2022-03-13',
    title: '[IJBC] 얼바인중앙침례교회 2022.03.13 주일예배',
    videoId: '5YcTW7iLidE'
  },
  {
    date: '2022-03-06',
    title: '[IJBC] 얼바인중앙침례교회 2022.03.06 주일예배',
    videoId: 'gx1JnqFpHLA'
  },
  {
    date: '2022-02-20',
    title: '[IJBC] 얼바인중앙침례교회  2022.2.20 주일예배',
    videoId: 'o0L86G8Lv8A'
  },
  {
    date: '2022-02-13',
    title: '[IJBC] 얼바인중앙침례교회  2022.2.13 주일예배',
    videoId: 'gKqfuGqWqjY'
  },
  {
    date: '2022-02-06',
    title: '[IJBC] 얼바인중앙침례교회  2022.2.06 주일예배',
    videoId: 'N6m2-8DLqXI'
  },
  {
    date: '2022-01-30',
    title: '[IJBC] 얼바인중앙침례교회  2022.1.30. 주일예배',
    videoId: 'hcucKsGLUVQ'
  },
  {
    date: '2022-01-23',
    title: '[IJBC] 얼바인중앙침례교회  2022.1.23. 주일예배',
    videoId: '9z3zFPO4z7I'
  },
  {
    date: '2022-01-16',
    title: '[IJBC] 얼바인중앙침례교회  2022.1.16. 주일예배',
    videoId: 'ie77Ij7QEZU'
  },
  {
    date: '2022-01-09',
    title: '[주일예배] 얼바인중앙침례교회  2022.1.9. 주일예배 전체영상',
    videoId: 'fRnemrpBnH4'
  },
  {
    date: '2022-01-02',
    title: '[주일예배] 얼바인중앙침례교회  2022.1.2. 주일예배 전체영상',
    videoId: 'nuFcAkuMNPU'
  },
  {
    date: '2021-12-26',
    title: '얼바인중앙침례교회  2021.12.26. 주일예배 전체영상',
    videoId: '1Gwho3yCuvg'
  },
  {
    date: '2021-12-19',
    title: '얼바인중앙침례교회  2021.12.19. 주일예배 전체영상',
    videoId: 'v5BZwNRCUy4'
  },
  {
    date: '2021-12-12',
    title: '얼바인중앙침례교회  2021.12.12. 주일예배 전체영상',
    videoId: 'aL5pwd5wHV4'
  },
  {
    date: '2021-12-05',
    title: '얼바인중앙침례교회  2021.12.5. 주일예배',
    videoId: 'Hn6ynP8w98o'
  },
  {
    date: '2021-11-28',
    title: '얼바인중앙침례교회  2021.11.28. 주일예배',
    videoId: 'FZxsqRheY2E'
  },
  {
    date: '2021-11-21',
    title: '얼바인중앙침례교회  2021.11.21. 추수감사절 주일예배',
    videoId: 'FfsrVNMccxw'
  },
  {
    date: '2021-11-14',
    title: '얼바인중앙침례교회 2021.11.14. 주일예배',
    videoId: 'Rw5VGmeQ6i8'
  },
  {
    date: '2021-11-07',
    title: 'IJBC 2021.11.07 주일영상예배 / 피영민 목사 / 포로된 여인과 결혼에 관한 법도',
    videoId: 'u8y1kJ6OMYs'
  },
  {
    date: '2021-10-24',
    title: 'IJBC 2021.10.24 주일영상예배 / 정성택 목사 / 성도가 역경을 만날 때 알아야 할 것',
    videoId: 'WFqN5T93Uv4'
  },
  {
    date: '2021-10-17',
    title: 'IJBC 2021.10.17 주일영상예배 / 피영민 목사 / 해결되지 않은 살인사건에 관한 규례',
    videoId: '0x64XfNrhQg'
  },
  {
    date: '2021-10-10',
    title: 'IJBC 2021.10.10 주일영상예배 / 정성택 목사 / 지식과 총명으로 풍성한 사랑을 구하라',
    videoId: 'hc41I05mGVE'
  },
  {
    date: '2021-10-03',
    title: 'IJBC 2021.10.03 주일영상예배 / 피영민 목사 / 전쟁에 관한 규례',
    videoId: 'Ak5RIjzhtFM'
  },
  {
    date: '2021-09-26',
    title: 'IJBC 2021.09.26 주일영상예배 / 정성택 목사 / 성도 안에 선한 일의 시작과 완성',
    videoId: 'fXLZhsswOVY'
  },
  {
    date: '2021-09-19',
    title: 'IJBC 2021.9.19 주일영상예배 / 피영민 목사 / 증인에 관한 규례와 법도',
    videoId: 'MzVLdUCCj5I'
  },
  {
    date: '2021-09-12',
    title: 'IJBC 2021.09.12 주일영상예배 / 정성택 목사 / 기쁨을 위한 4가지 동사',
    videoId: 'inELcg9KIfE'
  },
  {
    date: '2021-09-05',
    title: 'IJBC 2021.9.5 주일영상예배 / 피영민 목사 / 네 이웃의 지계석을 옮기지 말라',
    videoId: 'Kce_Q2PtSdw'
  },
  {
    date: '2021-08-29',
    title: 'IJBC 2021.08.29 주일영상예배 / 정성택 목사 / 그리스도 안에 있는 기쁨의 종',
    videoId: '2bRPQuhgeW4'
  },
  {
    date: '2021-08-22',
    title: 'IJBC 2021.8.22 주일영상예배 / 피영민 목사 / 도피성과 살인의 문제',
    videoId: 'EqI9MXxFhs0'
  },
  {
    date: '2021-08-15',
    title: 'IJBC 2021.08.15 주일영상예배 / 정성택 목사 / 교회를 세우시는 하나님 (빌립보교회 생성배경)',
    videoId: 'iNTsioMbEVY'
  },
  {
    date: '2021-08-08',
    title: 'IJBC 2021.8.8 주일영상예배 / 피영민 목사 / 선지자의 사역',
    videoId: 'bwqe5-nmhX4'
  },
  {
    date: '2021-08-01',
    title: 'IJBC 2021.08.01 주일영상예배 / 정성택 목사 / 마지막 축도',
    videoId: '7v05j4Vif_Y'
  },
  {
    date: '2021-07-25',
    title: 'IJBC 2021.7.25 주일영상예배 / 피영민 목사 / 점술의 가증함',
    videoId: 'E1TLkcxIYTs'
  },
  {
    date: '2021-07-18',
    title: 'IJBC 2021.07.18 주일영상예배 / 정성택 목사 / 영혼을 위하여 수고하라',
    videoId: '0IyB2L8M_KI'
  },
  {
    date: '2021-07-11',
    title: 'IJBC 2021.7.11 주일영상예배 / 피영민 목사 / 레위인과 제사장에 관한 규례',
    videoId: 'mVdOVgI9Jlg'
  },
  {
    date: '2021-07-04',
    title: 'IJBC 2021.07.04 주일영상예배 / 정성택 목사 / 우리의 삶은 하나님께 드리는 "찬미의 제사"입니다.',
    videoId: '0K8bOEwq7Po'
  },
  {
    date: '2021-06-27',
    title: 'IJBC 2021.6.27 주일영상예배 / 피영민 목사 / 왕에 관한 법도',
    videoId: '4odfsNH_n60'
  },
  {
    date: '2021-06-20',
    title: 'IJBC 2021.06.20 주일영상예배 / 정성택 목사 / "그리스도는 영원토록 동일하시느니라"가 의미하는 5가지 바른 교훈',
    videoId: 'QKPbPI-3FQo'
  },
  {
    date: '2021-06-13',
    title: 'IJBC 2021.6.13 주일영상예배 / 피영민 목사 / 판결하기 어려운 사건',
    videoId: 'Lxktn1IWDGg'
  },
  {
    date: '2021-06-06',
    title: 'IJBC 2021.06.06 주일영상예배 / 정성택 목사 / "흔들리지 않는 나라"를 받은 자들',
    videoId: '0QhTmSYnPeY'
  },
  {
    date: '2021-05-30',
    title: 'IJBC 2021.5.30 주일영상예배 / 피영민 목사 / 범죄의 소추에 관한 규례',
    videoId: 'WlCNCUnzwtM'
  },
  {
    date: '2021-05-23',
    title: 'IJBC 2021.5.23 주일영상예배 / 정성택 목사 / 믿음의 경주를 위한 "최고의 약속"',
    videoId: 'AczLJaNyOWk'
  },
  {
    date: '2021-05-16',
    title: 'IJBC 2021.5.16 주일영상예배 / 피영민 목사 / 재판장과 유사에 관한 규례',
    videoId: 'jPU5LVSHdcs'
  },
  {
    date: '2021-05-09',
    title: 'IJBC 2021.5.9 "가정의 달" 주일영상예배 / 정성택 목사 / 하나님이 기억하시는 가정',
    videoId: 'oqg60AGBi7w'
  },
  {
    date: '2021-05-02',
    title: 'IJBC 2021.5.2 주일영상예배 / 정성택 목사 / 거룩함이 없이는 주를 볼 수 없습니다.',
    videoId: 'xB2E-hIOrmg'
  },
  {
    date: '2021-04-25',
    title: 'IJBC 2021.4.25 주일영상예배 / 피영민 목사 / 두가지 특권을 가진 성도의 삶',
    videoId: 'wYGuusyK4aQ'
  },
  {
    date: '2021-04-18',
    title: 'IJBC 2021.4.18 주일영상예배 / 정성택 목사 / 믿음의 경주를 위해 "주님을 더욱 생각하십시다".',
    videoId: 'eIdJvj23WfI'
  },
  {
    date: '2021-04-11',
    title: 'IJBC 2021.4.11 주일영상예배 / 정성택 목사 / 이제 "믿음의 경주"를 합시다.',
    videoId: '_BQXEhlzQuI'
  },
  {
    date: '2021-04-04',
    title: 'IJBC 2021.4.4 부활주일영상예배 / 정성택 목사 / "부활의 주"를 믿는 "믿음"은 강한 것입니다',
    videoId: '2oQM3aWSeak'
  },
  {
    date: '2021-03-28',
    title: 'IJBC 2021.3.28 주일영상예배 / 정성택 목사 / 누구에게 "믿음"의 역사가 일어나는가?',
    videoId: 'eBcoRonHbLk'
  },
  {
    date: '2021-03-21',
    title: 'IJBC 2021.3.21 주일영상예배 / 최병락 목사(강남중앙침례교회 담임목사) / 교회란 무엇일까요?',
    videoId: 'KbsqlwCuhbY'
  },
  {
    date: '2021-03-14',
    title: 'IJBC 2021.3.14 주일영상예배 / 정성택 목사 / 구원을 얻게 하는 "믿음"',
    videoId: 'f20WGCB5Aig'
  },
  {
    date: '2021-03-07',
    title: 'IJBC 2021.3.7 주일영상예배 / 정성택 목사 / 두려움을 이기게 하는 "믿음"',
    videoId: 'DRwfnhd4-dc'
  },
  {
    date: '2021-02-28',
    title: 'IJBC 2021.2.28 주일영상예배 / 정성택 목사 / 그리스도를 위하여 결단하는 "믿음"',
    videoId: 'aqLTsqZTEtI'
  },
  {
    date: '2021-02-21',
    title: 'IJBC 2021.2.21 주일영상예배 / 정성택 목사 / 하나님의 계획을 확신하는 "믿음"',
    videoId: 'Ezs5wElVVJo'
  },
  {
    date: '2021-02-14',
    title: 'IJBC 2021.2.14 주일영상예배 / 정성택 목사 / 시험을 받는 "믿음"',
    videoId: 'iZsJlbqIwOY'
  },
  {
    date: '2021-02-07',
    title: 'IJBC 2021.2.7 주일영상예배 / 정성택 목사 / 성도의 삶을 이끄는 "믿음"',
    videoId: '156z8C-AR6M'
  },
  {
    date: '2021-01-31',
    title: 'IJBC 2021.1.31 주일영상예배 / 정성택 목사 / 더 나은 본향을 사모하는 나그네 "믿음"',
    videoId: 'N0d1qP_bzlI'
  },
  {
    date: '2021-01-24',
    title: 'IJBC 2021.1.24 주일영상예배 / 정성택 목사 / 믿음이 없이는 하나님을 기쁘시게 할 수 없습니다.',
    videoId: 'GprP0-9Tpkw'
  },
  {
    date: '2021-01-17',
    title: 'IJBC 2021.1.17 주일영상예배 / 피영민 목사 / 초막절 규례',
    videoId: 'EVe0gEn21HU'
  },
  {
    date: '2021-01-10',
    title: 'IJBC 2021.1.10 주일영상예배 / 정성택 목사 / 그러므로 이제 우리는...',
    videoId: 'p52d3nV2H0g'
  },
  {
    date: '2021-01-03',
    title: 'IJBC 2021.1.3 주일영상예배 / 피영민 목사 / 칠칠절 규례',
    videoId: 'v8sgOUgyXrM'
  },
  {
    date: '2020-12-27',
    title: 'IJBC 2020.12.27 주일영상예배 / 피영민 목사 / 유월절 규례',
    videoId: 'Ce7lhC06QvI'
  },
  {
    date: '2020-12-20',
    title: 'IJBC 2020.12.20 주일영상예배 / 정성택 목사 / 첫 것과 둘째 것',
    videoId: '8E1olt58jJA'
  },
  {
    date: '2020-12-13',
    title: 'IJBC 2020.12.13 주일영상예배 / 피영민 목사 / 히브리종과 초태생에 대한 법도와 규례(신명기 강해)',
    videoId: '3XGo8sUmCfc'
  },
  {
    date: '2020-12-06',
    title: 'IJBC 2020.12.06 주일영상예배 / 정성택 목사 / 그리스도의 초림과 승천 그리고 재림',
    videoId: 'ev02exDl3p4'
  },
  {
    date: '2020-11-29',
    title: 'IJBC 2020.11.29 주일영상예배 / 피영민 목사 / 면제년의 규례 (신명기 강해)',
    videoId: 'gHJFQ8FZBUg'
  },
  {
    date: '2020-11-22',
    title: 'IJBC 2020.11.22 추수감사절 주일영상예배 / 정성택 목사 / 감사함을 넘치게 하라',
    videoId: 'IRrthGuuawQ'
  },
  {
    date: '2020-11-15',
    title: 'IJBC 2020.11.15 주일영상예배 / 정성택 목사 / 주 밖에는 나의 복이 없나이다',
    videoId: 'voUEOtQni7s'
  },
  {
    date: '2020-11-08',
    title: 'IJBC 2020.11.08 주일영상예배 / 고흥식 목사(영통영락교회) / 꿈 꾸는 자',
    videoId: 'peauC7Otgsc'
  },
  {
    date: '2020-11-01',
    title: 'IJBC 2020.11.01 주일영상예배 / 정성택 목사 / 이는 "언약의 피"니라',
    videoId: 'hsK-TbtskDI'
  },
  {
    date: '2020-10-24',
    title: 'IJBC 2020.10.24 주일영상예배 / 정성택 목사 / 옛 언약과 새 언약',
    videoId: 'WZxbS7Onfjc'
  },
  {
    date: '2020-10-18',
    title: 'IJBC 2020.10.18 주일영상예배 / 정성택 목사 / 지극히 합당하신 대제사장 예수 그리스도',
    videoId: 'AOo0ZP1emUI'
  },
  {
    date: '2020-10-11',
    title: 'IJBC 2020.10.11 주일영상예배 / 피영민 목사 / 십일조 규례',
    videoId: 'PWHCWSHDs9M'
  },
  {
    date: '2020-10-04',
    title: 'IJBC 2020.10.04 주일영상예배 / 정성택 목사 / 얼마나 위대하신 분이신지를 생각하라',
    videoId: '6v5Xmm5P2HA'
  },
  {
    date: '2020-09-27',
    title: 'IJBC 2020.9.27 주일영상예배 / 피영민 목사 / 장례규례와 음식규례의 신약적인 의미',
    videoId: 'LpQ9L8MBoHs'
  },
  {
    date: '2020-09-20',
    title: 'IJBC 2020.9.20 주일영상예배 / 정성택 목사 / 구원의 확신이 주는 큰 유익',
    videoId: 'Xk3CcgdrL-g'
  },
  {
    date: '2020-09-13',
    title: 'IJBC 2020.9.13 주일영상예배 / 피영민 목사 / 영적 반역자를 물리치라',
    videoId: 'z4yDM-HjH3M'
  },
  {
    date: '2020-09-06',
    title: 'IJBC 2020.9.6 주일영상예배 / 정성택 목사 / 진리를 사모하는 참 성도',
    videoId: 'lgS4G2q916s'
  },
  {
    date: '2020-08-30',
    title: 'IJBC 2020.8.30 주일영상예배 / 피영민 목사 / 공예배의 규례와 법도',
    videoId: '_QsMNn8a3Po'
  },
  {
    date: '2020-08-23',
    title: 'IJBC 2020.8.23 주일영상예배/정성택 목사/영광을 나타내시는 하나님',
    videoId: 'D2k-ef9IZwM'
  },
  {
    date: '2020-08-16',
    title: 'IJBC 2020.8.16 주일영상예배/피영민 목사/야곱기도의 세가지 요소',
    videoId: 'HUcvJuJsStM'
  },
  {
    date: '2020-08-09',
    title: 'IJBC 2020.8.9 주일영상예배/정성택 목사/단단한 식물을 먹으라!',
    videoId: '6ZtwipyaqiQ'
  },
  {
    date: '2020-08-02',
    title: '시편 강해 7. 세상의 말과 하나님 말씀 (시 12:1-8) / 2020 08 02 주일설교 (정성택 목사)',
    videoId: '2xSoFygFw9E'
  },
  {
    date: '2020-08-02',
    title: 'IJBC 2020 08 02 주일영상예배/정성택 목사/"세상의 말"과 "하나님 말씀"',
    videoId: 'wWx1fyRh2ng'
  },
  {
    date: '2020-07-26',
    title: '히브리서 강해 12. 영원한 구원의 근원 예수 그리스도 (히 5:8-9) / 2020 07 26 주일설교 (정성택 목사)',
    videoId: '4o7LcJ8ZCxI'
  },
  {
    date: '2020-07-26',
    title: 'IJBC 2020.7.26 주일영상예배/정성택 목사/영원한 구원의 근원 예수 그리스도',
    videoId: 'qeo8Myhll0k'
  },
  {
    date: '2020-07-19',
    title: '시편 강해 6. 성도의 확신 (시 11:1-7) / 2020 07 19 주일설교 (정성택 목사)',
    videoId: 'JzjrJ4vFxCk'
  },
  {
    date: '2020-07-19',
    title: 'IJBC 2020.7.19 주일영상예배/정성택 목사/성도의 확신',
    videoId: 'sYqFMs0ZcPM'
  },
  {
    date: '2020-07-12',
    title: 'IJBC 2020 7 12 주일영상예배/정성택 목사/우리의 대제사장 "예수 그리스도"',
    videoId: 'Z3A1M0VzfMU'
  },
  {
    date: '2020-07-05',
    title: '시편 강해 5. "기억하라" 그리고 "찬양하라" (시 9:1-2,18) / 2020 07 05 주일설교 (정성택 목사)',
    videoId: 'EXNW3HzFE2o'
  },
  {
    date: '2020-07-05',
    title: 'IJBC 2020 7 5 주일영상예배/정성택 목사/기억하라 그리고 찬양하라',
    videoId: 'x4Lv-MJFdNg'
  },
  {
    date: '2020-06-28',
    title: '히브리서 강해 10. 은혜의 보좌로 나아가라 (히 4:14-16) / 2020 06 28 주일설교 (정성택 목사)',
    videoId: 'pMX8BEpLfs8'
  },
  {
    date: '2020-06-28',
    title: 'IJBC 2020 6 28 주일영상예배/정성택 목사/은혜의 보좌로 나아가라',
    videoId: 'ORmYrDgRTfI'
  },
  {
    date: '2020-06-21',
    title: '시편 강해 4. 영원한 기쁨의 정체 (시 5:11-12) / 2020 06 21 주일설교 (정성택 목사)',
    videoId: 'iWsLx35nXuc'
  },
  {
    date: '2020-06-21',
    title: '2020 6 21 주일영상설교',
    videoId: 'MvfEhlhHi3w'
  },
  {
    date: '2020-06-14',
    title: '히브리서 강해 9. 하나님 말씀의 권세(말씀의 가치) (히 4:12-13) / 2020 06 14 주일설교 (정성택 목사)',
    videoId: 'wlBnc8-E3gQ'
  },
  {
    date: '2020-06-14',
    title: '2020 06 14 주일영상예배 / 히브리서 4:12-13 / 히브리서 강해 9. 하나님 말씀의 권세 / 정성택 목사',
    videoId: '8Ww392iVPBU'
  },
  {
    date: '2020-06-07',
    title: '시편 강해 3. 고난을 능히 이기는 기쁨 (시 4:1-8) / 2020 06 07 주일설교 (정성택 목사)',
    videoId: 'gKvG6wQqs9I'
  },
  {
    date: '2020-06-07',
    title: '2020 06 07주일영상예배 / 시편 4:1-6 / 시편 강해 3. 고난을 능히 이기는 기쁨 / 정성택 목사',
    videoId: 'Xet0lthU1us'
  },
  {
    date: '2020-05-31',
    title: '히브리서 강해 8. 성도는 무엇을 두려워해야 하는가? (히 4:1-3) / 2020 05 31 주일설교 (정성택 목사)',
    videoId: '1XDVP_5-Rs4'
  },
  {
    date: '2020-05-31',
    title: '2020 05 31주일영상예배 / 히브리서 4:1-3 / 히브리서 강해 8. 성도가 두려워해야 할 것 / 정성택 목사',
    videoId: 'aNYAlWEUi5M'
  },
  {
    date: '2020-05-24',
    title: '시편 강해 2. 진실로 복 있는 사람(시 1:1-6) / 2020 05 24 주일설교 (정성택 목사)',
    videoId: 'ZYlv70Gxop0'
  },
  {
    date: '2020-05-24',
    title: '2020 05 24 주일영상예배 / 시편 1:1-6 / 시편 강해 2. 진실로 복 있는 사람 / 정성택 목사',
    videoId: 'dq-r4QZ2Uk0'
  },
  {
    date: '2020-05-17',
    title: '히브리서 강해 7. 지금도 말씀하시는 성령님 (히 3:7-11) / 2020 05 17 주일설교 (정성택 목사)',
    videoId: 'gv4UT5vab2g'
  },
  {
    date: '2020-05-17',
    title: '2020 05 17 주일영상예배 / 히브리서 3:7-11 / 히브리서 강해 7. 지금도 말씀하시는 성령님(성령이 이르신 바와 같이) / 정성택 목사',
    videoId: 'vSjJHXr7I_0'
  },
  {
    date: '2020-05-10',
    title: '시편 강해 1. 주의 복을 주의 백성에게 내리소서 (시 3:1-8) / 2020 05 10 주일설교 (정성택 목사)',
    videoId: 'y9z5FVVTnSo'
  },
  {
    date: '2020-05-10',
    title: '2020 05 10 주일영상예배 / 시편 3:1-8 /  주의 백성에게 주의 복을 내리소서 / 정성택 목사',
    videoId: 'M03lNWYV4ao'
  },
  {
    date: '2020-05-03',
    title: '히브리서 강해 6. 능히 도우시느니라 (히 2:9-18) / 2020 05 03 주일설교 (정성택 목사)',
    videoId: '2OP5uCVrKt8'
  },
  {
    date: '2020-05-03',
    title: '2020 05 03 주일영상예배 / 히브리서 2:9-18 / 히브리서 강해 6. 능히 도우시리라 / 정성택 목사',
    videoId: 'WGXtS50J-aE'
  },
  {
    date: '2020-04-26',
    title: '히브리서 강해 5. 더욱 간절히 삼가라 (히 2:1-4) / 2020 04 26 주일설교 (정성택 목사)',
    videoId: '1wv5XOFuqm4'
  },
  {
    date: '2020-04-26',
    title: '2020 04 26 주일영상예배 / 히브리서 2:1-4 / 히브리서 강해 5. 더욱 간절히 삼가라 / 정성택 목사',
    videoId: '6m_L3EajG0E'
  },
  {
    date: '2020-04-19',
    title: '오히려 소망이 있나니 (에스라 10장 1-4절) / 2020 04 19 주일 설교 (피영민 목사/특별강사)',
    videoId: 'TuNZ9X5gq_Y'
  },
  {
    date: '2020-04-19',
    title: '04 19 주일영상예배 / 에스라 10:1-4 / 오히려 소망이 있나니 / 피영민 목사',
    videoId: 'QzuYjToPfoo'
  },
  {
    date: '2020-04-12',
    title: '예수 그리스도의 부활의 의미 (베드로전서 1장 3-7절) / 2020 04 12 부활주일설교 (정성택 목사)',
    videoId: '0RUY3c_VOyo'
  },
  {
    date: '2020-04-05',
    title: '탄식과 고통가운데 서 있는 하나님의 목적 (로마서 8장 18-28절) / 2020.4.5 주일설교 (피영민 목사 /특별강사)',
    videoId: 'peFPUUd8uaA'
  },
  {
    date: '2020-04-05',
    title: '04 05 주일영상예배 / 로마서 8:18-28 / 탄식과 고통 가운데 서 있는 하나님의 목적 / 피영민 목사',
    videoId: 'WSAycvOtzDs'
  },
  {
    date: '2020-03-29',
    title: '03 29 주일영상예배 / 히브리서 1:4-6 / 내가 믿는 예수 그리스도 II (예수 그리스도의 본질) / 정성택 목사',
    videoId: 'Tn52qd18bWI'
  },
  {
    date: '2020-03-22',
    title: '새롭고 산 길 (히브리서 10장19-21절 ) / 2020.3.22 주일설교 (피영민 목사/특별강사)',
    videoId: '7Fo073QidTw'
  },
  {
    date: '2020-03-22',
    title: '3.22 주일 영상 예배 (히브리서 10:19-21) / 새롭고 산 길 / 피영민 목사',
    videoId: 'lJYS5RBA_Ek'
  },
  {
    date: '2020-03-08',
    title: '필요를 보시고 공급하시는 하나님 (창세기 22장1-14절) / 2020.3.8 주일설교 (피영민 목사/특별강사)',
    videoId: 'Zj0eMO0OXj4'
  },
  {
    date: '2020-02-23',
    title: '[IJBC] 얼바인중앙침례교회 2020.2.27 주일예배',
    videoId: 'WHZ4HQub0ts'
  },
  {
    date: '2020-02-23',
    title: '히브리서 강해2. 말씀하시는 하나님 II (히브리서1장1-2절) 2020 02 23 주일예배 (정성택 목사)',
    videoId: 'yzmDE9bxQ3U'
  },
  {
    date: '2020-02-16',
    title: '위대한 기도의 내용 (히브리서 13장20-21절) / 2020.2.16 주일설교 (피영민 목사/특별강사)',
    videoId: 'UrcNx9HtrYQ'
  },
  {
    date: '2020-02-09',
    title: '히브리서 강해1. 말씀하시는 하나님 (히브리서1장1-2절)  2020 02 09 주일설교 (정성택 목사)',
    videoId: 'I28sYTKvPlg'
  },
  {
    date: '2020-02-02',
    title: '튼튼하고 견고한 영혼의 닻 (히 6:13-20) / 2020.2.2 주일설교 (피영민 목사/특별강사)',
    videoId: 'GsjGKIoqUqo'
  },
  {
    date: '2020-01-26',
    title: '성도에게 있는 참된 믿음(에베소서 2장8-9절) / 2020. 1. 26 주일설교 (정성택 목사)',
    videoId: '5wljICCQCNM'
  },
  {
    date: '2020-01-19',
    title: '교회의 본질과 목적 (디모데전서 3장14-16절) / 2020. 1.19 주일설교 (피영민 목사/특별강사)',
    videoId: 'phr3pfNf6BQ'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 주일예배/신명기 강해 9]  마음의 할례를 받으라  (신명기 10:12-16)',
    videoId: '7Pn8ftrIsRE'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 주일예배/신명기 강해 8]  "말씀이 너를 살렸다"  (신명기 8:2-10)',
    videoId: '5gMg3peXO-E'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC 주일설교] 사도행전 강해 (교회를 세우시는 주님 시리즈 22) / 일어나라! (애니아와 다비다) / 사도행전 9:32-42 / 정성택 목사',
    videoId: 'DG0LTJFq03E'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC 주일설교] 사도행전 강해 (교회를 세우시는 주님 시리즈 21) / 바울의 회심 (회심에 대한 보편적 진리 ) / 사도행전 9:1-9, 20-22 / 정성택 목사',
    videoId: 'FY4E-RIbx30'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC 주일설교] 사도행전 강해 (교회를 세우시는 주님 시리즈 20) / 기이한 일 / 사도행전 8:26-31 / 정성택 목사 / 개혁주의 설교',
    videoId: '2wyBwK0XRU4'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC 주일설교] 사도행전 강해 (교회를 세우시는 주님 시리즈 19) / 그리스도인 이십니까? / 사도행전 8:13, 18-24 / 정성택 목사 / 개혁주의 설교',
    videoId: 'axukJ6B6nx8'
  },
  {
    date: 'Unknown Date',
    title: 'IJBC 부활주일영상예배 / 베드로전서 1:3-7 / 그리스도 부활의 의미 / 정성택 목사',
    videoId: 'FZMgQZeBLqc'
  },
];
